import React from 'react';

import metaData from 'marketing-website/data/metadata.js';

import Page from '../../components/modules/Page';
import Security from '../../components/modules/SecuritySection';
import ImageBlock from '../../components/modules/ImageBlock';
import assets from '../../configs/pages/enterprise/assets';

import Header from './Header.js';
import Logos from './Logos.js';
import VideoBlock from './VideoBlock.js';
import Experience from './Experience.js';
import Try from './Try.js';

const facebookMeta = [
  {
    name: 'og:title',
    content: 'The Platform for Large Teams to Scale Design',
  },
  {
    name: 'og:site_name',
    content: 'Marvel Enterprise',
  },
  {
    name: 'og:type',
    content: 'website',
  },
  {
    name: 'og:url',
    content: 'https://marvelapp.com/enterprise',
  },
  {
    name: 'og:description',
    content:
      'Join thousands of teams switching to Marvel Enterprise 3. The all new platform built so you can create amazing products at scale.',
  },
  {
    name: 'og:image',
    content: `https://marvelapp.com${assets.sharePreview.src}`,
  },
  {
    name: 'og:site_name',
    content: 'Marvel Enterprise',
  },
];

const twitterMeta = [
  {
    name: 'twitter:site',
    content: 'https://marvelapp.com/enterprise',
  },
  {
    name: 'twitter:creator',
    content: 'Marvel Enterprise',
  },
  {
    name: 'twitter:title',
    content: 'The Platform for Large Teams to Scale Design',
  },
  {
    name: 'twitter:image',
    content: `https://marvelapp.com${assets.sharePreview.src}`,
  },
];

const meta = {
  title:
    'Marvel Enterprise | The Design, Prototyping and User Testing Platform for Large Teams to Scale Design',
  meta: [
    {
      name: 'description',
      content: metaData.enterprise.description,
    },
    {
      name: 'keywords',
      content: metaData.enterprise.keywords,
    },
    ...twitterMeta,
    ...facebookMeta,
  ],
  header: { isLight: false },
  footer: true,
};

export default function Enterprise() {
  return (
    <Page {...meta}>
      <Header />
      <Logos />
      <ImageBlock
        paragraphSize="m"
        title="Seamlessly move from prototype to user test to developer handoff"
        copy="Consolidate your tools and give every team the power to problem solve together. Brainstorm, design, prototype, user test and handoff to developers on a single platform, accessible by designers, developers, researchers and stakeholders in a few clicks."
        headingMaxWidth={390}
        paragraphMaxWidth={480}
        imageAsset={assets.posterFeatures}
      />

      <ImageBlock
        paragraphSize="m"
        title="Effortlessly organise your work, design systems and documentation"
        copy="Folders make it easy to bunch together related ideas, prototypes and user test results with external links to your design systems, documentation and tasks - so you can share a single URL with your team, developers or wider stakeholders."
        headingMaxWidth={435}
        paragraphMaxWidth={435}
        imageAsset={assets.organise}
        isRightAligned
      />

      <ImageBlock
        title="Full visibility of new, ongoing and completed projects "
        copy="Whether it's what's new, what's in progress or what's finished, Marvel Enterprise centralises all team members activity into one stream, so management can quickly see what's in motion and stay on the same page."
        headingMaxWidth={458}
        paragraphMaxWidth={458}
        imageAsset={assets.team}
      />

      <VideoBlock
        title="Integrate, automate or build with your favourite tools "
        copy="We know that every workflow is different, that's why Marvel works with the likes of Sketch, JIRA, Slack and much more. If you need something more custom, our powerful GraphQL API allows you to roll your own workflows. No devs? No problem, Zapier integrates with over 1000+ apps and services."
        headingMaxWidth={459}
        paragraphMaxWidth={459}
        imageAsset={assets.organise}
        isRightAligned
        poster={assets.brainstorm.src}
        cloudinaryId="logos_animation"
        maxVideoWidth={642}
      />
      <Security />
      <Experience />
      <Try />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/enterprise/index.js